/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { HotLaunchProgram } from '../../programs/src/mint';
import { TokenConfig, MintResult } from '../../types/tokens';
import { NftProgram } from '../../programs/src/mint-nft';

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
}

/**
 * Client-Side "API" Wrapper
 * This now acts as the controller that bridges the UI form to the Blockchain logic.
 * It expects the `wallet` object to be passed in the `extra` param.
 */
export const mintTokenApi = async (
    data: TokenConfig & { userWalletAddress?: string; isNft?: boolean }, 
    walletProvider?: any
): Promise<ApiResponse<MintResult>> => {
  try {
    if (!walletProvider) {
        throw new Error("Wallet provider missing. Cannot sign transaction.");
    }

    let result;

    if (data.isNft || (data.supply === 1 && data.decimals === 0 && data.tags?.includes('NFT'))) {
        // Route to NFT Program
        result = await NftProgram.mintNft(data, walletProvider);
    } else {
        // Route to Standard Token Program
        result = await HotLaunchProgram.mintToken(data, walletProvider);
    }

    return { success: true, data: result };

  } catch (error: any) {
    console.error("Minting Fatal Error:", error);
    return { success: false, error: error.message || "Unknown error occurred during minting sequence." };
  }
};